import { Box, Flex, Text } from "@chakra-ui/react";
import { Lamp } from "iconsax-react";

// EG-38 (passo 7 BI) — narrativa inteligente: resume o painel em palavras reais,
// pro público que não lê gráfico tão bem quanto você. Derivada do dado.
// tone: 'info' (azul) | 'warn' (âmbar) | 'good' (verde).
const TONES = {
  info: { bg: "#E7F1FA", color: "#0A558C" },
  warn: { bg: "#FDF6EC", color: "#8A5A00" },
  good: { bg: "#E6F4EA", color: "#22633B" },
};

export default function Narrative({ children, tone = "info" }) {
  if (!children) return null;
  const c = TONES[tone] || TONES.info;
  return (
    <Flex bg={c.bg} borderRadius="12px" p="14px 18px" align="flex-start" gap="10px" mb="24px">
      <Box mt="1px" flexShrink={0}>
        <Lamp size="20" variant="Bulk" color={c.color} />
      </Box>
      <Text fontSize="14px" color={c.color} fontWeight={500} lineHeight="1.5">
        {children}
      </Text>
    </Flex>
  );
}
